import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_100: FaireProductEntity = {
  token: "starter_collection_100",
  type: "product",
  name: "Niko Stirring Carafe",
  brandName: "Be Home",
  imageUrl:
    '"https://cdn.faire.com/fastly/d10a9bc8a3f864935ebe2ee141c6fb5014821f49096db77c319038ad3e5533b5.webp?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=681',
  priceDollars: 28,
  msrpDollars: 56,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
